// Increment the version suffix when the cached data structure changes, so stale caches are
// invalidated across all users.
export const ME_CACHE_KEY = 'meQueryCache_v2'
export const ME_CACHE_TTL_MS = 24 * 60 * 60 * 1000
